import {AppBar, Container, CssBaseline} from '@mui/material';
import {ThemeProvider} from '@emotion/react';
import {Route, Routes} from 'react-router-dom';
import {API, ROUTES} from './routes';
import {appTheme} from './appTheme';
import DriverCheckInPage from './pages/DriverCheckInPage';
import DriverPortalPage from "./pages/driverportal/DriverPortalPage";
import imgUrl from './common/imageHelper'
import { RentalInfoPage} from "./pages/driverportal/RentalInfo";

function App() {
    return (
        <ThemeProvider theme={appTheme}>
            <CssBaseline/>
            <AppBar style={{
                background: 'black',
                position: 'static',
                minHeight: '80px',
                justifyContent: 'center',
            }}>
                <Container
                    maxWidth='xl'
                    style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <img src={imgUrl('/hertz-logo.png')} alt='hertz logo'
                         style={{height: '48px', width: '138px'}}/>
                </Container>
            </AppBar>
            <Container
                component='main'
                sx={{
                    paddingTop: '3em',
                }}
            >
                <Routes>
                    <Route
                        path={ROUTES.CHECK_IN}
                        element={<DriverCheckInPage/>}
                    />
                    <Route
                        path={ROUTES.CHECK_IN_OLD}
                        element={<DriverCheckInPage/>}
                    />
                    <Route
                        path={ROUTES.DRIVER_PORTAL}
                        element={<DriverPortalPage/>}
                    />
                    <Route
                        path={ROUTES.DRIVER_PORTAL_RENTAL_INFO}
                        element={<RentalInfoPage/>}
                    />
                </Routes>
            </Container>
        </ThemeProvider>
    );
}

export const submitCheckIn = async (baseUrl, oagCode, checkInRequest) => {
    return Promise.resolve(fetch(API.DRIVER_CHECK_IN(baseUrl, oagCode), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            mode: 'cors',
            body: JSON.stringify(checkInRequest)
        }
    ))
}

export default App;
